import { Folder } from '@common/entities';

import { destroy, get, patch, post } from '../config';

export const FOLDERS_END_POINTS = '/folders';

interface CreateFolder {
  name: string;
  sequence?: number;
  parentFolderId?: string;
}

type CreateFolderResponse = Folder;

export const createFolder = async (data: CreateFolder) => {
  const response = await post<CreateFolderResponse>(FOLDERS_END_POINTS, data);
  return response;
};

export const getFolders = async (clientId: number, parentFolderId?: string) => {
  if (!clientId) throw new Error('Please provide client Id.');

  const queryParams = new URLSearchParams({ clientid: clientId.toString() });
  if (parentFolderId) {
    queryParams.append('parentFolderId', parentFolderId);
  }

  const response = await get<Folder[]>(`${FOLDERS_END_POINTS}?${queryParams.toString()}`);
  return response;
};

export const searchFolders = async (clientId: number, search: string) => {
  if (!clientId) throw new Error('Please provide client Id.');
  if (!search || search.trim().length === 0) {
    return { data: [] };
  }

  const queryParams = new URLSearchParams({
    clientid: clientId.toString(),
    search: search.trim(),
  });

  const response = await get<Folder[]>(`${FOLDERS_END_POINTS}/search?${queryParams.toString()}`);
  return response;
};

interface UpdateFolder {
  name?: string;
  sequence?: number;
  parentFolderId?: string | null;
}

export const updateFolder = async (folderId: string, data: UpdateFolder) => {
  const response = await patch<Folder>(`${FOLDERS_END_POINTS}/${folderId}`, data);
  return response;
};

export const deleteFolder = async (folderId: string) => {
  const response = await destroy<Folder>(`${FOLDERS_END_POINTS}/${folderId}`);
  return response;
};
